import { lazy } from 'react';

export { default as UserLogin } from './user_login/UserLogin';
export { default as ChangePassword } from './change_password/ChangePassword';

export const Profile = lazy(() => import('./profile/Profile'));
export const UserList = lazy(() => import('./user/UserList'));
export const AddUser = lazy(() => import('./user/AddUser'));
export const UpdateUser = lazy(() => import('./user/UpdateUser'));
export const UserDetails = lazy(() => import('./user/UserDetails'));